import type { TOC } from '@ember/component/template-only';

import CommonFullscreenLoaderComponent from 'webapp/components/common/fullscreen-loader';

const OnboardingLoadingRouteTemplate: TOC<object> = <template>
	<CommonFullscreenLoaderComponent />
</template>;

export default OnboardingLoadingRouteTemplate;
